import React, { useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";

const BulkMissingSalesUploadModal = ({
    show,
    handleClose,
    uploadBulkMissingSales,
    sampleFileUrl,
}) => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    const closeModal = () => {
        setFile(null);
        setUploading(false);
        handleClose();
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files && e.target.files[0] ? e.target.files[0] : null;
        setFile(selectedFile);
    };

    const handleUpload = async () => {
        if (!file) return;

        try {
            setUploading(true);
            await uploadBulkMissingSales(file);
            closeModal();
        } finally {
            setUploading(false);
        }
    };

    return (
        <Modal show={show} onHide={closeModal} centered>
            <Modal.Header closeButton>
                <Modal.Title>Bulk Missing Sales Upload</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mb-3">
                    <p className="mb-2">
                        Upload the completed Excel file for bulk missing sales.
                    </p>

                    <a
                        href={sampleFileUrl}
                        download
                        className="btn btn-sm btn-outline-primary"
                    >
                        Download Sample File
                    </a>
                </div>

                <Form.Group>
                    <Form.Label>Upload Excel file</Form.Label>
                    <Form.Control
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleFileChange}
                    />
                </Form.Group>

                <div className="mt-2 text-muted" style={{ fontSize: 12 }}>
                    Use the sample file format to avoid upload errors.
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={closeModal}
                    disabled={uploading}
                >
                    Close
                </Button>

                <Button
                    variant="warning"
                    onClick={handleUpload}
                    disabled={!file || uploading}
                >
                    {uploading ? "Uploading..." : "Upload"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BulkMissingSalesUploadModal;